/**
 * Define html contents mixin
 *
 * @author minkyoung.park@emcast.com
 */

//  check screen mode
function isPortrait() {
    if (screen.orientation === undefined) {
        return window.orientation === 0 || window.orientation === 180;
    } else {
        return screen.orientation.angle === 0;
    }
}

export const htmlTypeMixins = {    
    data() {
        return {
            // Elements from HTML
            imagesContainer: null,
            btnClose: null,
            playlistContainer: null,
            btnPlaylistClose: null,
            btnPlaylistToggle: null,
            isFirstScreenVisible: true,
            isPortrait: isPortrait(),
            mainTransitionName: 'fade',
            isVideoVisible: true,
            isLecturesVisible: true,
            isControlsVisible: true,
            isOverIframe: false
        }
    },

    
    mounted() {
        const elementHtml = document.querySelector('html')
        const elementBody = document.querySelector('body')

        window.addEventListener('orientationchange', () => {
            this.isPortrait = isPortrait();

            if (!this.isPortrait) {
                elementHtml.classList.add('no-scroll');
                elementBody.classList.add('no-scroll');
            } else {
                elementHtml.classList.remove('no-scroll');
                elementBody.classList.remove('no-scroll');
            }

            // After orientationchange, add a one-time resize event
            const afterOrientationChange = () => {
                setTimeout(() => {
                    this.onOrientationChanged(false);
                }, 150); // Fix for iOS

                window.removeEventListener('resize', afterOrientationChange);
            };
            window.addEventListener('resize', afterOrientationChange);
        });

        this.isPortrait = isPortrait();

        if (!this.isPortrait) {
            elementHtml.classList.add('no-scroll');
            elementBody.classList.add('no-scroll');
        } else {
            elementHtml.classList.add('no-scroll');
            elementBody.classList.add('no-scroll');
        }
        
        document.querySelector('#videoContainer').addEventListener('click', (e) => {
            console.log('videoContainer click');
            
            e.preventDefault();
            e.stopPropagation();

            if (!this.isPortrait) {
                if(elementBody.classList.contains('overlay')) {
                    elementBody.classList.remove('overlay');
                }else {
                    elementBody.classList.add('overlay');
                }
                
            }
        });

        this.imagesContainer = document.querySelector('#videoContainer > div:first-child');
        this.playlistContainer = document.getElementById('playlistContainer');
        this.btnClose = document.getElementById('btnClose');
        this.btnPlaylistClose = document.getElementById('btnPlaylistClose');
        this.btnPlaylistToggle = document.getElementById('btnPlaylistToggle');
        this.btnClose.addEventListener('click', () => {
            const body = document.getElementsByTagName('body')[0];
            if (body.classList.contains('overlay')) {
                body.classList.remove('overlay');
            }
        });
    },
    methods: {
        onToggleAllPages: function () {
            document.querySelector('body').classList.remove('overlay');
            this.isAllPages = !this.isAllPages
            if (document.querySelector('body').classList.contains('all-pages')) {
                document.querySelector('body').classList.remove('all-pages');
                this.isAllPages = false
            } else {
                document.querySelector('body').classList.add('all-pages');
                this.isAllPages = true
            }
        },
        onExitClick: function () {
            if (this.isPortrait) {

            } else {
                if (this.isFirstScreenVisible) {
                    this.isFirstScreenVisible = false;
                }
            }
        },
        onTogglePlaylist: function () {
            this.onOrientationChanged(true);
        },
        onToggleQnA: function () {
            if (!document.getElementsByTagName('body')[0].classList.contains('qna-overlay')) {
                this.mainTransitionName = 'slide-up';
                this.isVideoVisible = false;
                this.isControlsVisible = false;

                setTimeout(() => {
                    document.getElementsByTagName('body')[0].classList.add('qna-overlay');
                    this.isQnAVisible = true;
                }, 500);
            } else {
                setTimeout(() => {
                    document.getElementsByTagName('body')[0].classList.remove('qna-overlay');
                    this.mainTransitionName = 'slide-up';
                    this.isVideoVisible = true;
                    this.isControlsVisible = true;
                    setTimeout(() => {
                        this.mainTransitionName = 'fade';
                    }, 500);
                }, 500);
                this.isQnAVisible = false;
            }
        },
        
        onOrientationChanged: function (onClick) {
            const elementBody = document.querySelector('body')
            document.body.scrollTop = document.documentElement.scrollTop = 0;
            
            const showInPortrait = () => {
                document.getElementsByTagName('html')[0].classList.remove('no-scroll');
                document.getElementsByTagName('body')[0].classList.remove('no-scroll');

                this.playlistContainer.style.top = window.outerHeight - 50 + 'px';
                this.playlistContainer.style.position = 'absolute';
                
                setTimeout(() => { // To launch animation.
                    this.playlistContainer.style.top = '0px';
                }, 1);

                document.getElementsByClassName('lectures-list')[0].style.height = window.outerHeight - 50 + 'px';
            };

            const showInLandscape = () => {
                const marginX = 1.5 * parseFloat(getComputedStyle(document.documentElement).fontSize);
                this.playlistContainer.style.top = '0';
                this.playlistContainer.style.left = '0';
                this.playlistContainer.style.position = 'fixed';
                const lecturesList = document.getElementsByClassName('lectures-list')[0].childNodes[0];
                const lectureWidth = lecturesList.childNodes[0].clientWidth;

                document.getElementsByClassName('lectures-list')[0].childNodes[0].style.width = 
                ((marginX + 24) * 2) + (lectureWidth * lecturesList.childNodes.length) + 'px';

                document.getElementsByTagName('html')[0].classList.add('no-scroll');
                elementBody.classList.add('no-scroll');
            };

            if (this.playlistContainer.classList.contains('show')) {
                if (this.isPortrait) {
                    document.getElementsByTagName('html')[0].classList.remove('no-scroll');
                    document.getElementsByTagName('body')[0].classList.remove('no-scroll');

                    if (onClick) {
                        const style = this.playlistContainer.currentStyle || window.getComputedStyle(this.playlistContainer);
                        this.playlistContainer.style.top = window.outerHeight - 50 + (window.outerHeight <= 568 ? parseInt(style.paddingTop, 10) : 0) + 'px';

                        setTimeout(() => {
                            this.playlistContainer.classList.remove('show');
                            this.showLectureList = false
                            this.playlistContainer.style.position = 'initial';
                            this.playlistContainer.style.top = 'initial';
                        }, 200);
                        
                        this.isVideoVisible = true
                        this.isControlsVisible = true
                        // console.log('여기냐');
                        
                    } else {
                        // setTimeout(() => {
                        document.getElementsByClassName('lectures-list')[0].childNodes[0].style.width = 'initial';
                        showInPortrait();
                        // }, 50); // For Perform Orientation Change
                    }
                } else {
                    if (onClick) {
                        this.playlistContainer.style.top = '100vh';
                        setTimeout(() => {
                            this.mainTransitionName = 'slide-up';
                            this.isVideoVisible = true;
                            this.isControlsVisible = true;
                            this.playlistContainer.classList.remove('show');
                            this.showLectureList = false
                            this.playlistContainer.style.position = 'initial';
                            setTimeout(() => {
                                this.mainTransitionName = 'fade';
                            }, 500);
                        }, 200);

                    } else {
                        showInLandscape();
                    }
                }
            } else if (!this.playlistContainer.classList.contains('show') && onClick) {
                if (this.isPortrait) {
                    if (onClick) {
                        this.playlistContainer.classList.add('show');
                        this.showLectureList = true
                    }
                    showInPortrait();
                } else {
                    if (onClick) {
                        this.mainTransitionName = 'slide-up';
                        this.isVideoVisible = false;
                        this.isControlsVisible = false;
                        this.playlistContainer.style.top = '100vh';

                        setTimeout(() => {
                            this.playlistContainer.classList.add('show');
                            this.showLectureList = true
                            showInLandscape();
                        }, 200);
                    } else {
                        showInLandscape();
                    }
                }
            } else {
                
                this.isVideoVisible = true
                this.isControlsVisible = true
            }
        },
        onLike: function () {
            this.isLiked = !this.isLiked;
            const element = document.getElementById('likeIcon');
            element.classList.add('fade', 'show');
            setTimeout(() => {
                element.classList.add('hide');
                setTimeout(() => {
                    element.classList.remove('fade', 'show', 'hide');
                }, 300);
            }, 1000 + 300);
        },
        onBookmark: function () {
            this.isBookmarked = !this.isBookmarked;
            const element = document.getElementById('bookmarkIcon');
            element.classList.add('fade', 'show');
            setTimeout(() => {
                element.classList.add('hide');
                setTimeout(() => {
                    element.classList.remove('fade', 'show', 'hide');
                }, 300);
            }, 1000 + 300);
        },
    }
}